import React, { useState } from "react";
import "./UserEmailTable.scss";
import Eye from "../../images/eye.svg";
import { getCardHolderEmailBody } from "../../util/API/customers";
import EmailBodyModal from "../EmailBodyModal/EmailBodyModal";

function UserEmailTable({ emailData }) {
  const [email, setEmail] = useState();
  const [open, setOpen] = useState(false);

  let isAdmin = sessionStorage.getItem("isAdmin");


  const handleOpen = async (id) => {
    const getEmailBodyResponse = await getCardHolderEmailBody(id, isAdmin);

    let emailBody = getEmailBodyResponse.data.payload.record.emaillog.emailtext;
    setOpen(true);
    setEmail(emailBody);
  };
  const handleClose = () => setOpen(false);

  //@Param date: format `YYYY-MM-DD HH:MM:SS`
  const formatDate = (date) => {
    const [day, time] = date.split(" ");
    return { day: day.slice(2, 10), time };
  };

  console.log("emailData=========",emailData);

  return (
    <>
      {email ? (
        <EmailBodyModal open={open} handleClose={handleClose} email={email} />
      ) : (
        <></>
      )}

      <table className="full-width-table">
        <thead>
          <tr className="header-row">
            <th className="table-date-header">Date/Time</th>
            <th className="table-date-header">Email</th>
            <th>Message ID</th>
            <th></th>
          </tr>
        </thead>
        {emailData ? (
          <tbody>
            {emailData.record &&
              emailData.record.length &&
              emailData.record.map((item, index) => (
                <tr key={index}>
                  {/* <td>{index}</td> */}
                  <td>
                    <div style={{ display: "block" }}>
                      <p>{formatDate(item?.emaillog?.emailtime).day}</p>
                      <p>{formatDate(item?.emaillog?.emailtime).time}</p>
                    </div>
                  </td>
                  <td>{item.emaillog.email}</td>
                  <td>{item.emaillog.emailid}</td>
                  <td className="text-end ">
                    <img
                      src={Eye}
                      onClick={() => handleOpen(item.emaillog.emailid)}
                      loading="lazy"
                    />
                  </td>
                </tr>
              ))}
            {emailData.record &&
              emailData != false &&
              !emailData.record.length && (
                <tr key={1}>
                  <td>{1}</td>
                  <td>{emailData.emaillog.emailtime}</td>
                  <td>{emailData.emaillog.emailid}</td>
                  <td className="text-end pointer">
                    <img
                      src={Eye}
                      onClick={() => handleOpen(emailData.emaillog.emailid)}
                      className="pointer"
                      loading="lazy"
                    />
                  </td>
                </tr>
              )}
          </tbody>
        ) : (
          <>
            <tr>
              <td>No Email messages</td>
              <td></td>
              <td></td>
            </tr>
          </>
        )}
      </table>
    </>
  );
}

export default UserEmailTable;
